import { render } from "./BeaconForm.vue?vue&type=template&id=7ef024c8"
import script from "./BeaconForm.vue?vue&type=script&lang=ts"
export * from "./BeaconForm.vue?vue&type=script&lang=ts"
script.render = render

export default script